module.exports = __webpack_public_path__ + "img/welcome.69b6d117.png";